import Commons from '@/shared/utils/commons'

class Events {
  static init() {
    if (!isClient()) return
    window.autoIncrementId = 1
    window.customEventsHandlers = {}
    this.handleGlobalEvents()
  }

  static handleGlobalEvents() {
    window.addEventListener('message', this.handleWindowMessageEvent, false)
  }

  static handleWindowMessageEvent(event) {
    const eventName = event.data?.name
    const handlerIds = Object.keys(window.customEventsHandlers).filter(id =>
      id.startsWith(eventName),
    )
    handlerIds.forEach(id => window.customEventsHandlers[id](event))
  }

  static initKeepWorkerAlivePing() {
    if (!isClient()) return
    setInterval(() => {
      this.dispatchEvent('keep_worker_alive', { hide_log: true })
    }, 5000)
  }

  static async sendDataRequestResolve(dataName, data, timeout = 120000) {
    return new Promise(resolve => {
      this.sendDataRequest(dataName, resolve, data)
      setTimeout(resolve, timeout, null)
    })
  }

  static sendDataRequest(dataName, onResponse, data) {
    if (!isClient()) return {}
    const eventName = `request:${dataName}`
    const responseId = `response:${dataName}:${window.autoIncrementId++}`
    const eventId = this.dispatchEvent(eventName, { ...data, responseId })

    this.handleEvent(responseId, responseData => {
      this.removeHandler(eventId)
      onResponse(responseData)
    })

    return {
      responseId,
      unsubscribe: () => this.removeHandler(eventId),
    }
  }

  // 🔴 Supprimé: onDataResponse basé sur serviceWorker

  static dispatch(eventName, data = {}, delay = 0) {
    if (!isClient()) return null

    const isSystemEvent = /^(request|response):.+/.test(eventName)
    if (!isSystemEvent) this.onEventDispatched(eventName)

    setTimeout(() => {
      const detail = Commons.changeToJson(data)
      const customEvent = new CustomEvent(eventName, { detail })

      document.dispatchEvent(customEvent)

      // 🔴 Supprimé: serviceWorker.ready

      if (self !== top) {
        window.parent?.postMessage({ name: eventName, data: detail }, '*')
      }

      document.querySelectorAll('iframe[shareEvent]').forEach(iframe => {
        try {
          iframe.contentWindow?.postMessage(
            { name: eventName, data: detail },
            '*',
          )
        } catch (e) {
          console.log('Error to post message on iframe', eventName, e, iframe)
        }
      })
    }, delay)

    return `${eventName}----${Date.now()}-${window.autoIncrementId - 1}`
  }

  static handle(eventName, callback, unicId = null) {
    if (!isClient()) return null

    const isSystemEvent = /^(request|response):.+/.test(eventName)
    if (!isSystemEvent) this.onEventHandleAdded(eventName)

    const handlerKey = unicId || `${Date.now()}-${window.autoIncrementId++}`
    const id = `${eventName}----${handlerKey}`
    if (unicId) this.removeHandler(id)

    window.customEventsHandlers[id] = event => {
      if (event.constructor.name === 'MessageEvent') {
        if (event.data?.name === eventName) callback(event.data.data)
      } else if (event.constructor.name === 'CustomEvent') {
        callback(event.detail)
      }
    }

    document.addEventListener(eventName, window.customEventsHandlers[id])
    return id
  }

  static removeHandler(id) {
    if (!isClient() || !id || !window.customEventsHandlers[id]) return

    const eventName = id.split('----')[0]
    // 🔴 Supprimé: navigator.serviceWorker.removeEventListener
    document.removeEventListener(eventName, window.customEventsHandlers[id])
    delete window.customEventsHandlers[id]
  }

  static onEventNotRegistered(eventName) {
    window.notRegisteredEvents = window.notRegisteredEvents || {}
    window.notRegisteredEvents[eventName] = eventName
  }

  static onEventHandleAdded(eventName) {
    window.eventsWithHandle = window.eventsWithHandle || {}
    window.eventsWithHandle[eventName] = eventName
  }

  static onEventDispatched(eventName) {
    window.dispatchedEvents = window.dispatchedEvents || {}
    window.dispatchedEvents[eventName] = eventName
  }
}

function isClient() {
  try {
    return typeof window !== 'undefined'
  } catch (error) {
    return false
  }
}

export default Events
